/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolVolcanoIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-volcano"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M18.93 22.82L5.58 22.82Q4.13 22.82 3.35 21.63Q2.58 20.43 3.15 19.1L5.1 14.75Q5.42 14.03 6.08 13.6Q6.72 13.18 7.53 13.18L8.78 13.18L10.1 9.85Q10.4 9.1 11.09 8.64Q11.78 8.18 12.57 8.18L16.25 8.18Q17.13 8.18 17.84 8.7Q18.55 9.22 18.8 10.1L21.48 19.45Q21.82 20.73 21.04 21.77Q20.25 22.82 18.93 22.82ZM12.93 3.75L12.93 1.75Q12.93 1.2 13.31 0.81Q13.7 0.42 14.25 0.42Q14.8 0.42 15.19 0.81Q15.57 1.2 15.57 1.75L15.57 3.75Q15.57 4.3 15.19 4.69Q14.8 5.08 14.25 5.08Q13.7 5.08 13.31 4.69Q12.93 4.3 12.93 3.75ZM17.35 4.55L18.77 3.13Q19.15 2.75 19.69 2.74Q20.23 2.73 20.63 3.1Q21.02 3.5 21.02 4.05Q21.02 4.6 20.63 5L19.2 6.42Q18.82 6.8 18.29 6.8Q17.75 6.8 17.35 6.4Q16.98 6.03 16.98 5.47Q16.98 4.92 17.35 4.55ZM9.3 6.4L7.88 4.97Q7.5 4.6 7.49 4.06Q7.47 3.52 7.85 3.13Q8.25 2.73 8.8 2.73Q9.35 2.73 9.75 3.13L11.18 4.55Q11.55 4.92 11.55 5.46Q11.55 6 11.15 6.4Q10.78 6.78 10.22 6.78Q9.68 6.78 9.3 6.4Z" fill={color} />
    </svg>
  );
}
